export const SESSIONS_LOADING = 'SESSIONS_LOADING';
export const ALL_SESSIONS = 'ALL_SESSIONS';
export const ALL_UNAUTH_SESSIONS = 'ALL_UNAUTH_SESSIONS';
export const MY_SESSIONS = 'MY_SESSIONS';
export const SESSIONS_ERROR = 'SESSIONS_ERROR';
export const SESSIONS_RESET = 'SESSIONS_RESET';
export const SESSIONS_SUCCESS = 'SESSIONS_SUCCESS';
export const SPECIFIC_SESSION = 'SPECIFIC_SESSION';
export const REGISTER_FOR_SESSION = 'REGISTER_FOR_SESSION';
